<template>
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.583 17.17H5.44299C4.20289 17.1698 3.01353 16.6777 2.1358 15.8016C1.25807 14.9256 0.763634 13.7372 0.760986 12.4971V5.18701C0.763634 3.94691 1.25807 2.75849 2.1358 1.88245C3.01353 1.0064 4.20289 0.5143 5.44299 0.514038H14.583C15.8244 0.516283 17.0147 1.00865 17.895 1.88403C18.3302 2.31619 18.6754 2.83041 18.9105 3.39685C19.1457 3.9633 19.2662 4.57076 19.265 5.18408V12.494C19.2631 13.7346 18.7691 14.9238 17.8913 15.8005C17.0135 16.6772 15.8236 17.1698 14.583 17.17ZM4.49399 5.37C4.40185 5.36939 4.31057 5.38758 4.22565 5.42334C4.14073 5.4591 4.06395 5.51167 4 5.578C3.87938 5.69835 3.80629 5.85824 3.79416 6.0282C3.78203 6.19816 3.83168 6.3668 3.93399 6.50305L4.05499 6.62305L8.26498 9.90808C8.77694 10.3146 9.41126 10.5362 10.065 10.537C10.722 10.5356 11.3596 10.3142 11.876 9.90808L16.05 6.56799L16.124 6.49402C16.2319 6.36344 16.2899 6.19889 16.2879 6.02954C16.2859 5.86019 16.2239 5.69707 16.113 5.56909C15.9851 5.43217 15.8115 5.34669 15.625 5.32898H15.586C15.4083 5.32749 15.2367 5.39369 15.106 5.51404L10.934 8.84509C10.674 9.06064 10.3468 9.17833 10.009 9.17798C9.67163 9.17618 9.34508 9.05875 9.08398 8.84509L4.92499 5.51404C4.80097 5.41976 4.64976 5.36822 4.49399 5.36707V5.37Z"
            :fill="color || '#EC4B1D'"
        />
    </svg>
</template>
<script>
export default {
    name: "Email",
    props: ["color"],
};
</script>



// WEBPACK FOOTER //
// src/components/V2/svg/components/Email.vue